export const COUNTRIES = [
    { value: 'AF', label: 'Afghanistan (AF)' },
    { value: 'AL', label: 'Albania (AL)' },
    { value: 'DZ', label: 'Algeria (DZ)' },
    { value: 'AD', label: 'Andorra (AD)' },
    { value: 'AO', label: 'Angola (AO)' },
    { value: 'AG', label: 'Antigua and Barbuda (AG)' },
    { value: 'AR', label: 'Argentina (AR)' },
    { value: 'AM', label: 'Armenia (AM)' },
    { value: 'AU', label: 'Australia (AU)' },
    { value: 'AT', label: 'Austria (AT)' },
    { value: 'AZ', label: 'Azerbaijan (AZ)' },
    { value: 'BS', label: 'Bahamas (BS)' },
    { value: 'BH', label: 'Bahrain (BH)' },
    { value: 'BD', label: 'Bangladesh (BD)' },
    { value: 'BB', label: 'Barbados (BB)' },
    { value: 'BY', label: 'Belarus (BY)' },
    { value: 'BE', label: 'Belgium (BE)' },
    { value: 'BZ', label: 'Belize (BZ)' },
    { value: 'BJ', label: 'Benin (BJ)' },
    { value: 'BT', label: 'Bhutan (BT)' },
    { value: 'BO', label: 'Bolivia (BO)' },
    { value: 'BA', label: 'Bosnia and Herzegovina (BA)' },
    { value: 'BW', label: 'Botswana (BW)' },
    { value: 'BR', label: 'Brazil (BR)' },
    { value: 'BN', label: 'Brunei (BN)' },
    { value: 'BG', label: 'Bulgaria (BG)' },
    { value: 'BF', label: 'Burkina Faso (BF)' },
    { value: 'BI', label: 'Burundi (BI)' },
    { value: 'CV', label: 'Cabo Verde (CV)' },
    { value: 'KH', label: 'Cambodia (KH)' },
    { value: 'CM', label: 'Cameroon (CM)' },
    { value: 'CA', label: 'Canada (CA)' },
    { value: 'CF', label: 'Central African Republic (CF)' },
    { value: 'TD', label: 'Chad (TD)' },
    { value: 'CL', label: 'Chile (CL)' },
    { value: 'CN', label: 'China (CN)' },
    { value: 'CO', label: 'Colombia (CO)' },
    { value: 'KM', label: 'Comoros (KM)' },
    { value: 'CG', label: 'Congo (CG)' },
    { value: 'CD', label: 'Congo, DR (CD)' },
    { value: 'CR', label: 'Costa Rica (CR)' },
    { value: 'HR', label: 'Croatia (HR)' },
    { value: 'CU', label: 'Cuba (CU)' },
    { value: 'CY', label: 'Cyprus (CY)' },
    { value: 'CZ', label: 'Czechia (CZ)' },
    { value: 'DK', label: 'Denmark (DK)' },
    { value: 'DJ', label: 'Djibouti (DJ)' },
    { value: 'DM', label: 'Dominica (DM)' },
    { value: 'DO', label: 'Dominican Republic (DO)' },
    { value: 'EC', label: 'Ecuador (EC)' },
    { value: 'EG', label: 'Egypt (EG)' },
    { value: 'SV', label: 'El Salvador (SV)' },
    { value: 'GQ', label: 'Equatorial Guinea (GQ)' },
    { value: 'ER', label: 'Eritrea (ER)' },
    { value: 'EE', label: 'Estonia (EE)' },
    { value: 'SZ', label: 'Eswatini (SZ)' },
    { value: 'ET', label: 'Ethiopia (ET)' },
    { value: 'FJ', label: 'Fiji (FJ)' },
    { value: 'FI', label: 'Finland (FI)' },
    { value: 'FR', label: 'France (FR)' },
    { value: 'GA', label: 'Gabon (GA)' },
    { value: 'GM', label: 'Gambia (GM)' },
    { value: 'GE', label: 'Georgia (GE)' },
    { value: 'DE', label: 'Germany (DE)' },
    { value: 'GH', label: 'Ghana (GH)' },
    { value: 'GR', label: 'Greece (GR)' },
    { value: 'GD', label: 'Grenada (GD)' },
    { value: 'GT', label: 'Guatemala (GT)' },
    { value: 'GN', label: 'Guinea (GN)' },
    { value: 'GW', label: 'Guinea-Bissau (GW)' },
    { value: 'GY', label: 'Guyana (GY)' },
    { value: 'HT', label: 'Haiti (HT)' },
    { value: 'HN', label: 'Honduras (HN)' },
    { value: 'HU', label: 'Hungary (HU)' },
    { value: 'IS', label: 'Iceland (IS)' },
    { value: 'IN', label: 'India (IN)' },
    { value: 'ID', label: 'Indonesia (ID)' },
    { value: 'IR', label: 'Iran (IR)' },
    { value: 'IQ', label: 'Iraq (IQ)' },
    { value: 'IE', label: 'Ireland (IE)' },
    { value: 'IL', label: 'Israel (IL)' },
    { value: 'IT', label: 'Italy (IT)' },
    { value: 'JM', label: 'Jamaica (JM)' },
    { value: 'JP', label: 'Japan (JP)' },
    { value: 'JO', label: 'Jordan (JO)' },
    { value: 'KZ', label: 'Kazakhstan (KZ)' },
    { value: 'KE', label: 'Kenya (KE)' },
    { value: 'KI', label: 'Kiribati (KI)' },
    { value: 'KP', label: 'Korea, North (KP)' },
    { value: 'KR', label: 'Korea, South (KR)' },
    { value: 'KW', label: 'Kuwait (KW)' },
    { value: 'KG', label: 'Kyrgyzstan (KG)' },
    { value: 'LA', label: 'Laos (LA)' },
    { value: 'LV', label: 'Latvia (LV)' },
    { value: 'LB', label: 'Lebanon (LB)' },
    { value: 'LS', label: 'Lesotho (LS)' },
    { value: 'LR', label: 'Liberia (LR)' },
    { value: 'LY', label: 'Libya (LY)' },
    { value: 'LI', label: 'Liechtenstein (LI)' },
    { value: 'LT', label: 'Lithuania (LT)' },
    { value: 'LU', label: 'Luxembourg (LU)' },
    { value: 'MG', label: 'Madagascar (MG)' },
    { value: 'MW', label: 'Malawi (MW)' },
    { value: 'MY', label: 'Malaysia (MY)' },
    { value: 'MV', label: 'Maldives (MV)' },
    { value: 'ML', label: 'Mali (ML)' },
    { value: 'MT', label: 'Malta (MT)' },
    { value: 'MH', label: 'Marshall Islands (MH)' },
    { value: 'MR', label: 'Mauritania (MR)' },
    { value: 'MU', label: 'Mauritius (MU)' },
    { value: 'MX', label: 'Mexico (MX)' },
    { value: 'FM', label: 'Micronesia (FM)' },
    { value: 'MD', label: 'Moldova (MD)' },
    { value: 'MC', label: 'Monaco (MC)' },
    { value: 'MN', label: 'Mongolia (MN)' },
    { value: 'ME', label: 'Montenegro (ME)' },
    { value: 'MA', label: 'Morocco (MA)' },
    { value: 'MZ', label: 'Mozambique (MZ)' },
    { value: 'MM', label: 'Myanmar (MM)' },
    { value: 'NA', label: 'Namibia (NA)' },
    { value: 'NR', label: 'Nauru (NR)' },
    { value: 'NP', label: 'Nepal (NP)' },
    { value: 'NL', label: 'Netherlands (NL)' },
    { value: 'NZ', label: 'New Zealand (NZ)' },
    { value: 'NI', label: 'Nicaragua (NI)' },
    { value: 'NE', label: 'Niger (NE)' },
    { value: 'NG', label: 'Nigeria (NG)' },
    { value: 'MK', label: 'North Macedonia (MK)' },
    { value: 'NO', label: 'Norway (NO)' },
    { value: 'OM', label: 'Oman (OM)' },
    { value: 'PK', label: 'Pakistan (PK)' },
    { value: 'PW', label: 'Palau (PW)' },
    { value: 'PA', label: 'Panama (PA)' },
    { value: 'PG', label: 'Papua New Guinea (PG)' },
    { value: 'PY', label: 'Paraguay (PY)' },
    { value: 'PE', label: 'Peru (PE)' },
    { value: 'PH', label: 'Philippines (PH)' },
    { value: 'PL', label: 'Poland (PL)' },
    { value: 'PT', label: 'Portugal (PT)' },
    { value: 'QA', label: 'Qatar (QA)' },
    { value: 'RO', label: 'Romania (RO)' },
    { value: 'RU', label: 'Russia (RU)' },
    { value: 'RW', label: 'Rwanda (RW)' },
    { value: 'KN', label: 'Saint Kitts and Nevis (KN)' },
    { value: 'LC', label: 'Saint Lucia (LC)' },
    { value: 'VC', label: 'Saint Vincent and the Grenadines (VC)' },
    { value: 'WS', label: 'Samoa (WS)' },
    { value: 'SM', label: 'San Marino (SM)' },
    { value: 'ST', label: 'Sao Tome and Principe (ST)' },
    { value: 'SA', label: 'Saudi Arabia (SA)' },
    { value: 'SN', label: 'Senegal (SN)' },
    { value: 'RS', label: 'Serbia (RS)' },
    { value: 'SC', label: 'Seychelles (SC)' },
    { value: 'SL', label: 'Sierra Leone (SL)' },
    { value: 'SG', label: 'Singapore (SG)' },
    { value: 'SK', label: 'Slovakia (SK)' },
    { value: 'SI', label: 'Slovenia (SI)' },
    { value: 'SB', label: 'Solomon Islands (SB)' },
    { value: 'SO', label: 'Somalia (SO)' },
    { value: 'ZA', label: 'South Africa (ZA)' },
    { value: 'SS', label: 'South Sudan (SS)' },
    { value: 'ES', label: 'Spain (ES)' },
    { value: 'LK', label: 'Sri Lanka (LK)' },
    { value: 'SD', label: 'Sudan (SD)' },
    { value: 'SR', label: 'Suriname (SR)' },
    { value: 'SE', label: 'Sweden (SE)' },
    { value: 'CH', label: 'Switzerland (CH)' },
    { value: 'SY', label: 'Syria (SY)' },
    { value: 'TW', label: 'Taiwan (TW)' },
    { value: 'TJ', label: 'Tajikistan (TJ)' },
    { value: 'TZ', label: 'Tanzania (TZ)' },
    { value: 'TH', label: 'Thailand (TH)' },
    { value: 'TL', label: 'Timor-Leste (TL)' },
    { value: 'TG', label: 'Togo (TG)' },
    { value: 'TO', label: 'Tonga (TO)' },
    { value: 'TT', label: 'Trinidad and Tobago (TT)' },
    { value: 'TN', label: 'Tunisia (TN)' },
    { value: 'TR', label: 'Turkey (TR)' },
    { value: 'TM', label: 'Turkmenistan (TM)' },
    { value: 'TV', label: 'Tuvalu (TV)' },
    { value: 'UG', label: 'Uganda (UG)' },
    { value: 'UA', label: 'Ukraine (UA)' },
    { value: 'AE', label: 'United Arab Emirates (AE)' },
    { value: 'GB', label: 'United Kingdom (GB)' },
    { value: 'US', label: 'United States (US)' },
    { value: 'UY', label: 'Uruguay (UY)' },
    { value: 'UZ', label: 'Uzbekistan (UZ)' },
    { value: 'VU', label: 'Vanuatu (VU)' },
    { value: 'VE', label: 'Venezuela (VE)' },
    { value: 'VN', label: 'Vietnam (VN)' },
    { value: 'YE', label: 'Yemen (YE)' },
    { value: 'ZM', label: 'Zambia (ZM)' },
    { value: 'ZW', label: 'Zimbabwe (ZW)' },
];
